import React from "react";
import { Text, Tooltip } from "@chakra-ui/react";

const UuidPreview = ({ uuid, fontSize = "sm" }) => {

  if (!uuid || uuid.length < 10) {
    return <Text fontSize={fontSize}>{uuid}</Text>;
  }

  const preview = `${uuid.slice(0, 5)}...${uuid.slice(-5)}`;

  return (
    <Tooltip label={uuid} aria-label="Full UUID">
      <Text fontSize={fontSize} cursor="help">
        ({preview})
      </Text>
    </Tooltip>
  );
};

export default React.memo(UuidPreview);
